import { Box } from "react-bulma-components";
import { useTranslation } from "react-i18next";

export function LoadingSessions() {
  const { t, i18n } = useTranslation();

  return (
    <Box>
      <p className="title">{t("modal.loadingSessions.title")}</p>
      <p className="subtitle">{t("modal.loadingSessions.subtitle")}</p>
    </Box>
  )
}